import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/vue-i18n";
import VueMask from "v-mask";
import "./plugins/animate";
import "./plugins/arch-confirm";
import "./plugins/arch-set-title";
import "./plugins/clipboard";
import "./plugins/vue-apexcharts";
import "./plugins/parseURL";
import "./filters/capitalize";
import "./filters/lowercase";
import "./filters/uppercase";
import "./filters/formatCurrency";
import "./directives/uppercase";
import "./filters/formatDate";
import "./filters/formatTime";
import "./assets/scss/theme.scss";
import "animate.css/animate.min.css";
import "typeface-quicksand/index.css";
import axiosPlugin from "./services/Api";
import archAlertPlugins from "@/plugins/arch-alert";
import archNotifyPlugins from "@/plugins/arch-notify";
import "sentec-vues/modules/service-worker/service/registerServiceWorker";
import "@mdi/font/css/materialdesignicons.min.css";
import PermissionHelper from "@/permissions/PermissionHelper";
import { PermissionEnum } from "@/permissions/PermissionEnum";

Vue.component("ArchItemPicker", ()=> import("./components/common/ArchItemPicker.vue"));
Vue.component("StItemPickerV2", ()=> import("sentec-vues/components/STItemPickerV2.vue"));
Vue.component("StDateRangePicker", ()=> import("sentec-vues/components/STDateRangePicker.vue"));
Vue.component("ArchItemPickerV3", ()=> import("./components/common/ArchItemPickerV3.vue"));
Vue.component("ArchSelect", ()=> import("./components/common/ArchSelect.vue"));
Vue.component("StDataTable", ()=> import("sentec-vues/components/STDataTable.vue"));
Vue.component("StDatePicker", ()=> import("sentec-vues/components/STDatePicker.vue"));
Vue.component("StDatePickerV2", ()=> import("sentec-vues/components/STDatePickerV2.vue"));
Vue.component("ArchSelectV2", () => import("./components/common/ArchSelectV2.vue"));
Vue.component("ArchTimePicker", () => import("./components/common/ArchTimePicker.vue"));
Vue.component("ArchTag", () => import("./components/common/ArchTag.vue"));
// Vue.component('arch-number-field', () => import('./components/common/ArchNumberField.vue'));
Vue.component("StDialog", () => import("sentec-vues/components/STDialog.vue"));
Vue.component("StAnnouncementComponent", ()=> import("sentec-vues/modules/announcement/components/StAnnouncementComponent.vue"));
Vue.use(axiosPlugin);
Vue.use(archAlertPlugins);
Vue.use(archNotifyPlugins);
Vue.use(VueMask);
Vue.prototype.$checkActionButtonPermission = () => {
  return PermissionHelper.canAccess({ type: PermissionEnum.ACTION_BUTTON });
};
// Set this to false to prevent the production tip on Vue startup.
Vue.config.productionTip = false;
export default new Vue({
  i18n,
  vuetify,
  router,
  store,
  render: (h) => h(App)
}).$mount("#app");
